export type EvaluationQuestion = {
    id: number;
    title: string;
};

export type QuestionType = {
    authorizeWeightDistribution: boolean;
    canAnswerBeUpdated: boolean;
    id: number;
    isSecret: boolean;
    maxNumberOfAnswers: number;
    minNumberOfAnswers: number;
    numberOfSeats: number;
    multiSubmit: boolean;
    title: string;
    subTitles: Array<string>;
    evaluationQuestions: Array<EvaluationQuestion>;
    type: string;
    allowDuplicate: boolean;
    minValue: number;
    maxValue: number;
    useDecimal: boolean;
    evaluationDisplayType: EvaluationDisplayType;
    propositions: Array<{
        disableOtherPropositionsIfSelected: boolean;
        id: string;
        text: string;
        shortText: string;
        isVisibleByDefault: boolean;
        description: string;
        image: string;
    }>;
    description?: string;
    // Voter ids whose answer is already recorded server side (holder and proxies included).
    // Optional: older backends do not send it.
    answeredVoterIds?: Array<string>;
};

export type DataVoteType = {
    isReopened: boolean;
    questions: Array<QuestionType>;
    voteTitle: string;
    publicKey: string;
};

export enum EvaluationDisplayType {
    NUMBER = "number",
    STARS = "stars",
    HEARTS = "hearts",
    SMILES = "smiles",
}
